/**
 * Mirrors `CRM::CommitteePolicy#manage?` for section committees and person-profile section governance
 * (`CRM::GovernanceRolePolicy#manage?` for section governables): `manageCommittees` or JWT `manage_section?`.
 * See pgahq/pga-backend `app/policies/crm/committee_policy.rb` and `governance_role_policy.rb`.
 */
export function canManageSectionCommittee({
  isGlobalAdmin,
  assignedSectionLegacyIds,
  sectionLegacyId,
  hasManageCommitteesCapability
}: {
  isGlobalAdmin: boolean;
  assignedSectionLegacyIds: readonly string[];
  sectionLegacyId?: string | null;
  hasManageCommitteesCapability: boolean;
}): boolean {
  if (isGlobalAdmin) return true;
  if (!sectionLegacyId) return false;
  if (hasManageCommitteesCapability) return true;
  return assignedSectionLegacyIds.includes(sectionLegacyId);
}

export function canManageAnySectionCommittee({
  isGlobalAdmin,
  assignedSectionLegacyIds,
  hasManageCommitteesCapability
}: {
  isGlobalAdmin: boolean;
  assignedSectionLegacyIds: readonly string[];
  hasManageCommitteesCapability: boolean;
}): boolean {
  return isGlobalAdmin || hasManageCommitteesCapability || assignedSectionLegacyIds.length > 0;
}
